import * as React from 'react';
import { useSelector } from 'react-redux';
import { AppBar, Toolbar, Container, Typography } from '@mui/material';
import http from 'Utils/http';

const { version } = require('../../../package.json');

const LARAVEL_VERSION = '3.9.5';
const SYMFONY_VERSION = '3.5.0';

const REDIS_MEMORY_REFRESH_MS = 60000;
const MB = 1048576;

const redisMemoryColor = (percent, spillRatio) => {
    if (percent >= 95) {
        return '#ef5350';
    }

    return percent >= spillRatio * 100 ? '#ffa726' : '#99a1ad';
};

const RedisMemory = () => {
    const [memory, setMemory] = React.useState(null);

    React.useEffect(() => {
        const load = () => http.get('/redis/memory')
            .then((res) => setMemory(res.data))
            .catch(() => setMemory(null));

        load();
        const timer = setInterval(load, REDIS_MEMORY_REFRESH_MS);

        return () => clearInterval(timer);
    }, []);

    if (!memory || memory.percent === null) {
        return null;
    }

    return (
        <Typography sx={{ fontSize: '0.75rem', color: redisMemoryColor(memory.percent, memory.spill_ratio) }}>
            Redis {Math.round(memory.used / MB)} / {Math.round(memory.max / MB)} MB ({memory.percent}%)
        </Typography>
    );
};

const Footer = () => {
    const year = new Date().getFullYear();
    const access = useSelector((state) => state.auth.user?.access);

    React.useEffect(() => {
        if (!version || localStorage.getItem('version') === version) {
            return;
        }
        sessionStorage.clear();
        localStorage.setItem('version', version);
    }, []);

    return (
        <AppBar position="static" component="footer">
            <Container maxWidth={false}>
                <Toolbar disableGutters>
                    {(access === 'Admin' || access === 'Company Admin') && <RedisMemory />}
                    <Typography
                        sx={{
                            marginLeft: 'auto',
                            fontWeight: 600,
                        }}
                    >
                        Version {version} / {LARAVEL_VERSION} / {SYMFONY_VERSION}
                        <br/>© Infintegration, 2022 - {year}
                    </Typography>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default Footer;
